export const showAddMakeModal = () => {
    return {
      type: "SHOW_ADD_MAKE_MODAL",
    };
  };
  
  export const hideAddMakeModal = () => {
    return {
      type: "HIDE_ADD_MAKE_MODAL",
    };
  };
  